import { isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull } from "./Utils"

export const PERMISSION_TYPE = {
    LOCATION: 'LOCATION',
    EMPLOYEE: 'EMPLOYEE',
    PROJECT: 'PROJECT',
    SHIFT: 'SHIFT',
    TASK: 'TASK',
    REQUEST: 'REQUEST',
    DOCUMENTS: 'DOCUMENTS',
    POLICIES: 'POLICIES',
    ASSET: 'ASSET',
    PERFORMANCE: 'PERFORMANCE',
    AUDIT: 'AUDIT',
    VISITOR: 'VISITOR',
    PAYROLL: 'PAYROLL',
    SUPPLIES: 'SUPPLIES'
}

export const PERMISSION_SUB_TYPE = {
    LOCATION: {
        VIEW_ALL_LOCATIONS: 'viewAllLocatons',
        ADD_LOCATION: 'addLocation',
        UPDATE_LOCATION: 'updateLocation'
    },
    EMPLOYEE: {
        ADD_EMPLOYEE: 'addEmployee',
        REMOVE_EMPLOYEE: 'removeEmployee',
        UPDATE_EMPLOYEE: 'updateEmployee'
    },
    PROJECT: {
        ADD_PROJECT: 'addProject',
        VIEW_COSTING: 'viewCosting',
        UPDATE_DETAILS: 'updateProjectDetails',
        ACCEPT_REJECT_EMPLOYEE_REQUEST: 'acceptOrRejectEmployeeRequest'
    },
    SHIFT: {
        ADD_SHIFT: 'addShift',
        UPDATE_SHIFT: 'updateShift',
        ACCEPT_REJECT_EMPLOYEE_REQUEST: 'acceptOrRejectEmployeeRequest'
    },
    TASK: {
        ADD_TASK: 'addTask',
        ASSIGN_TASK: 'assignTask',
        REMOVE_EMPLOYEE_TASK: 'removeEmployeeTask'
    },
    REQUEST: {
        ACCEPT_REJECT_REQUEST: 'acceptOrRejectRequest'
    },
    DOCUMENTS: {
        ADD_DOCUMENT: 'addDocument'
    },
    POLICIES: {
        ADD_POLICY: 'addPolicy'
    },
    ASSET: {
        ADD_ASSET: 'addAsset',
        VIEW_ALL_ASSET: 'viewAllAsset',
        ASSIGN_ASSET: 'assignAsset',
        UPDATE_ASSET: 'updateAsset'
    },
    PERFORMANCE: {
        VIEW_ALL_EMPLOYEE_PERFORMANCE: 'viewAllEmployeePerformance'
    },
    AUDIT: {
        ADD_AUDIT: 'addAudit',
        VIEW_ALL_AUDIT: 'viewAllAudit',
        UPDATE_AUDIT_STATUS: 'updateAuditStatus',
        ASSIGN_AUDIT: 'assignAudit'
    },
    VISITOR: {
        VIEW_VISITOR_BOOK: "viewVisitorBook",
        UPDATE_ENTRY_SETTINGS: 'updateEntrySettings'
    },
    PAYROLL: {
        MANAGE_TAX_RULES: 'manageTaxRules',
        MANAGE_EMPLOYEE_PAYROLL: 'manageEmployeePayroll'
    },
    SUPPLIES: {
        VIEW_MERCHANT: 'viewMerchant',
        ADD_MERCHANT: 'addMerchant',
        MANAGE_MERCHANT: 'manageMerchant',
        VIEW_CATEGORIES: 'viewCategories',
        ADD_CATEGORY: 'addCategory',
        VIEW_ITEM: 'viewItem',
        ADD_ITEM: 'addItem',
        MANAGE_ITEM: 'manageItem'
    }
}

export const isPermissionAllowedMenu = (permissionType, user, businessId = null, locationId = null) => {
    if (isLoggedInUserBusiness(user)) {
        return true
    } else if (isLoggedInUserEmployee(user)) {
        if (!isNull(user.data.userDetails.employeeDetails) &&
            !isEmpty(user.data.userDetails.employeeDetails.permissions)) {
            const itemObj = user.data.userDetails.employeeDetails.permissions.find(item => item.type === permissionType)
            if (!isNull(itemObj) &&
                itemObj.businessId === businessId &&
                itemObj.locationId === locationId) {
                return true
            } else return false
        }
    } else return false
}


export const checkFunctionalityPermission = (user, permissionType, permissionSubType, employeeSelectedBusiness, employeeSelectedLocation) => {
    if (isLoggedInUserBusiness(user)) {
        return true
    } else if (isLoggedInUserEmployee(user)) {
        const itemObj = user.data.userDetails.permissions.find(item => (item.type === permissionType && item.businessId === employeeSelectedBusiness && item.locationId === employeeSelectedLocation))
        if (!isEmpty(itemObj)) {
            if (!isEmpty(permissionSubType)) {
                if (!isEmpty(itemObj[permissionSubType]) && itemObj[permissionSubType] === true) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        } else {
            return false
        }
    } else {
        return false
    }
}

export const checkOptionPermission = (user, permissionType, employeeSelectedBusiness, employeeSelectedLocation) => {
    if (isLoggedInUserBusiness(user)) {
        return true
    } else if (isLoggedInUserEmployee(user)) {
        const itemObj = user.data.userDetails.permissions.find(item => (item.type === permissionType && item.businessId === employeeSelectedBusiness && item.locationId === employeeSelectedLocation))
        if (!isEmpty(itemObj)) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}